<template>
    <div>
        <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
            :showButtons="panel.showButtons">
            <div slot="content-main">
                <div>
                    <br />
                    <br />
                    <StepByStep />
                </div>
            </div>
        </Panel>
    </div>
</template>

<script>

import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import StepByStep from '../../../components/modules/tax-document/wizard/StepByStep.vue';

import { mapMutations } from "vuex";

export default {
    name: "ConfigTaxDocumentView",
    components: { Panel, StepByStep, StepByStep },
    data() {
        return {
            idCertificate: "",
            panel: {
                module: "Nota Fiscal",
                title: "Passo a Passo",
                showFilter: false,
                showSearch: false,
                showButtons: false,
            },
        };
    },
    mounted() {
        this.removeLoading(["panel"]);
    },
    methods: {
        ...mapMutations("generic", ["removeLoading"]),
    },
};
</script>
